var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 0.75C3.5 0.335786 3.16421 0 2.75 0C2.33579 0 2 0.335786 2 0.75V4.10352C0.845748 4.42998 0 5.49122 0 6.75C0 8.26878 1.23122 9.5 2.75 9.5C4.26878 9.5 5.5 8.26878 5.5 6.75C5.5 5.49122 4.65425 4.42998 3.5 4.10352V0.75ZM2.75 5.5C2.05964 5.5 1.5 6.05964 1.5 6.75C1.5 7.44036 2.05964 8 2.75 8C3.44036 8 4 7.44036 4 6.75C4 6.05964 3.44036 5.5 2.75 5.5ZM3.5 11.75C3.5 11.3358 3.16421 11 2.75 11C2.33579 11 2 11.3358 2 11.75V18.75C2 19.1642 2.33579 19.5 2.75 19.5C3.16421 19.5 3.5 19.1642 3.5 18.75V11.75ZM12 12.75C12 13.4404 11.4404 14 10.75 14C10.0596 14 9.5 13.4404 9.5 12.75C9.5 12.0596 10.0596 11.5 10.75 11.5C11.4404 11.5 12 12.0596 12 12.75ZM11.5 15.3965V18.75C11.5 19.1642 11.1642 19.5 10.75 19.5C10.3358 19.5 10 19.1642 10 18.75V15.3965C8.84575 15.07 8 14.0088 8 12.75C8 11.2312 9.23122 10 10.75 10C12.2688 10 13.5 11.2312 13.5 12.75C13.5 14.0088 12.6543 15.07 11.5 15.3965ZM11.5 0.75C11.5 0.335786 11.1642 0 10.75 0C10.3358 0 10 0.335786 10 0.75V7.75C10 8.16421 10.3358 8.5 10.75 8.5C11.1642 8.5 11.5 8.16421 11.5 7.75V0.75Z",
    fill: "url(#paint0_linear_3388_65016)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3388_65016",
    x1: 6.75,
    y1: -10.9846,
    x2: -12.9886,
    y2: 1.14481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504968,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.4a6c50f0f45e13ad733a897714a1825c.svg";
export { ForwardRef as ReactComponent };